<template>
    <v-layout justify-center>
        <v-responsive max-width="1440" width="100%">
            <list-heading v-model="showSearch" title="작품 목록">
                <template #buttons>
                    <work-classifications-view>
                        <template #activator="{attrs,on}">
                            <v-tooltip left transition="fade-transition">
                                <template #activator="tooltipProps">
                                    <span v-bind="tooltipProps.attrs" v-on="tooltipProps.on">
                                        <v-btn icon text v-bind="attrs" v-on="on">
                                            <v-icon>mdi-settings</v-icon>
                                        </v-btn>
                                    </span>
                                </template>
                                작품상세정보 기본값 설정
                            </v-tooltip>
                        </template>
                    </work-classifications-view>
                </template>
            </list-heading>
            <v-btn-toggle v-model="filter.mode_auction" tile color="secondary">
                <v-btn class="px-6" :value="null">전체</v-btn>
                <v-btn class="px-6" :value="PROGRAM.value">{{ PROGRAM.text }}</v-btn>
                <v-btn class="px-6" :value="PRIVATE.value">{{ PRIVATE.text }}</v-btn>
            </v-btn-toggle>
            <v-data-table :items="items" :headers="headers" hide-default-footer disable-sort class="my-4">
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                <template #[`item.isSoldOut`]="{ value, item }">
                    <v-switch v-model="item.isSoldOut" inset dense hide-details class="pa-0 ma-0" @click="save({ _id: item._id, isSoldOut: !value })">
                        <span slot="label" class="subtitle-2"> {{ value ? "판매완료" : "판매중" }} </span>
                    </v-switch>
                </template>
                <v-row slot="item.imgs" slot-scope="{ value }" align="center" no-gutters>
                    <v-col cols="auto" class="py-4 pr-2">
                        <work-imgs-overlay :imgs="value">
                            <template #activator="{ attrs, on }">
                                <v-img width="48" height="48" :src="value?.[0]?.url" v-bind="attrs" v-on="on" style="cursor: pointer" />
                            </template>
                        </work-imgs-overlay>
                    </v-col>
                    <v-col cols="auto">{{ value?.length || 0 > 1 ? `X ${value.length}` : "" }}</v-col>
                </v-row>
                <template #[`item._bids`]="{value, item}">
                    <work-bids-list v-if="item.mode_auction == PROGRAM.value" :work="item">
                        <template #activator="{attrs,on}">
                            <v-btn v-bind="attrs" v-on="on" block height="100%" tile color="secondary"> {{ value?.length }}건 </v-btn>
                        </template>
                    </work-bids-list>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-btn v-if="filter.mode_auction == PROGRAM.value" icon text color="secondary" :disabled="!item.isAuctionEnded" @click="email(item)">
                        <v-icon>mdi-email</v-icon>
                    </v-btn>
                    <work-view :value="item" @input="update">
                        <template #activator="{ attrs, on }">
                            <v-btn v-bind="attrs" v-on="on" text icon color="primary"><v-icon>mdi-pencil</v-icon></v-btn>
                        </template>
                    </work-view>
                    <v-btn icon text color="red" @click="remove(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="my-4" @input="search()" />
            <work-view @input="update">
                <template #activator="{ attrs, on }">
                    <v-btn v-bind="attrs" v-on="on" fab fixed right bottom color="primary" large><v-icon>mdi-pencil</v-icon></v-btn>
                </template>
            </work-view>
        </v-responsive>
    </v-layout>
</template>

<script>
import WorkView from "@/components/console/auction/work-view.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import WorkBidsList from "@/components/console/auction/work-bids-list.vue";
import WorkImgsOverlay from "@/components/console/auction/work-imgs-overlay.vue";
import WorkClassificationsView from "@/components/console/auction/work-classifications-view.vue";

import api from "@/api";
import { WORK_AUCTION_MODES } from "@/assets/variables";
const { PROGRAM, PRIVATE } = WORK_AUCTION_MODES;
const formatter_dateTime = (value) => value?.toDateTime?.() || "-";

export default {
    components: {
        WorkView,
        ListHeading,
        WorkBidsList,
        WorkImgsOverlay,
        WorkClassificationsView,
    },
    data() {
        return {
            ///////////////////////////////////////////////
            // 검색필터
            ///////////////////////////////////////////////
            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                mode_auction: this.$route.query.mode_auction || null,
            },

            page: +this.$route.query.page || 1,
            totalCount: 0,
            limit: 10,

            works: [],
            PROGRAM,
            PRIVATE,
        };
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit);
        },
        items() {
            return (this.works || []).map((item, index) => ({ ...item, index: +this.totalCount - (+this.page - 1) * +this.limit - index }));
        },
        headers() {
            if (this.filter.mode_auction == null)
                return [
                    { text: "번호", value: "index", width: 60 },
                    { text: "유형", value: "modeText_auction", width: 100 },
                    { text: "LOT", value: "lot", width: 130 },
                    { text: "연도", value: "year", width: 70 },
                    { text: "작가명", value: "author.name.ko", width: 130 },
                    { text: "작품명", value: "subject", width: 130 },
                    { text: "이미지", value: "imgs", width: 110 },
                    { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
                    { text: "", value: "actions", width: 110, align: "right" },
                ];
            if (this.filter.mode_auction == PRIVATE.value)
                return [
                    { text: "번호", value: "index", width: 60 },
                    { text: "LOT", value: "lot", width: 130 },
                    { text: "연도", value: "year", width: 70 },
                    { text: "작가명", value: "author.name.ko", width: 130 },
                    { text: "작품명", value: "subject", width: 130 },
                    { text: "이미지", value: "imgs", width: 110 },
                    { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
                    { text: "판매처리", value: "isSoldOut", width: 150 },
                    { text: "", value: "actions", width: 110, align: "right" },
                ];
            if (this.filter.mode_auction == PROGRAM.value)
                return [
                    { text: "번호", value: "index", width: 60 },
                    { text: "프로그램", value: "program.subject", width: 110, formatter: (value) => value || "-" },
                    { text: "상태", value: "isAuctionEnded", width: 110, formatter: (value) => (value ? "경매종료" : "-") },
                    { text: "그룹", value: "group", width: 110, formatter: (value) => value || "-" },
                    { text: "LOT", value: "lot", width: 130 },
                    { text: "연도", value: "year", width: 70 },
                    { text: "작가명", value: "author.name.ko", width: 130 },
                    { text: "작품명", value: "subject", width: 130 },
                    { text: "이미지", value: "imgs", width: 110 },
                    { text: "응찰내역", value: "_bids", width: 110 },
                    { text: "작성일", value: "createdAt", width: 110, formatter: formatter_dateTime },
                    { text: "", value: "actions", width: 140, align: "right" },
                ];
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        $route() {
            this.search(false);

            Object.assign(this.filter, this.$route.query);
            this.page = +this.$route.query.page || 1;
        },
        "filter.mode_auction"() {
            this.works = [];
            this.page = 1;
            this.search(true);
        },
    },
    methods: {
        init() {
            this.search(false);
        },
        manualSearch() {
            this.page = 1;
            this.search();
        },
        async search(routable = true) {
            if (routable) this.$router.push({ query: Object.assign({}, this.filter, { page: this.page }) });

            var {
                summary: { totalCount },
                works,
            } = await api.console.auction.works.gets({
                headers: { skip: (this.page - 1) * this.limit, limit: this.limit },
                params: this.filter,
            });

            this.works = works;
            this.totalCount = totalCount;
        },
        async remove(item) {
            if (!confirm(`작가를 삭제하시겠습니까?\n\n제목:    "${item?.subject || ""}"\n작성일: ${item?.createdAt?.toDateTime()}`)) return;

            await api.console.auction.works.delete(item);
            this.works = this.works.filter((content) => content._id !== item._id);
            alert("작가가 삭제되었습니다.");
        },
        async save(item) {
            const { work } = await api.console.auction.works.put(item);
            this.update(work);
        },
        async update(item) {
            const index = this.works.findIndex(({ _id }) => _id == item._id);
            if (index > -1) this.works.splice(index, 1, item);
            else {
                this.works = [item, ...this.works];
                this.totalCount += 1;
            }
        },
        async email(item) {
            const go = confirm(`다음의 내용으로 낙찰 통보서를 발송합니다.\n\n작가/작품: ${item?.author?.name?.ko || "미상"} / ${item?.subject || "무제"}\n수신자: ${item?.price_auction?.bid?.user?.email || "없음"}`);

            if (go) await api.console.auction.works.postWonEmail(item);
        },
    },
};
</script>
